class MarmetoProductCard extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      const swatchImage = event.target.closest(".bgImg");
      if (!swatchImage || !this.contains(swatchImage)) return;

      event.preventDefault();
      event.stopPropagation();
      this.variantChange(swatchImage);
    });
  }

  variantChange(swatchImage) {
    const swatch = swatchImage.closest(".swatch-element");
    const input = swatch?.querySelector("input[data-variant][data-handle]");

    if (!input) return;

    const selectedVariant = input.dataset.variant;
    const productHandle = input.dataset.handle || this.dataset.handle;

    if (!selectedVariant || !productHandle) return;

    const subtitleHTML = this.querySelector(".product-card__subtitle")?.outerHTML;
    const variantUrl = `/products/${productHandle}?view=mm-product-card&variant=${selectedVariant}`;

    this.dataset.loadingVariant = "true";

    fetch(variantUrl, {
      credentials: "same-origin",
      cache: "no-store",
    })
      .then((response) => response.text())
      .then((data) => {
        const html = new DOMParser().parseFromString(data, "text/html");
        const responseCard =
          html.querySelector(`marmeto-product-card[data-handle="${CSS.escape(productHandle)}"]`) ||
          html.querySelector("marmeto-product-card");

        if (!responseCard) return;

        this.innerHTML = responseCard.innerHTML;
        this.dataset.handle = productHandle;

        const variantInput = this.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (variantInput) {
          variantInput.disabled = false;
          variantInput.value = selectedVariant;
          variantInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        if (subtitleHTML && !this.querySelector(".product-card__subtitle")) {
          const titleContainer = this.querySelector(".product--details__container");
          if (titleContainer) titleContainer.insertAdjacentHTML("beforeend", subtitleHTML);
        }
      })
      .catch((error) => {
        console.error("Marmeto upsell variant change error:", error);
      })
      .finally(() => {
        delete this.dataset.loadingVariant;
      });
  }
}

if (!customElements.get("marmeto-product-card")) {
  customElements.define("marmeto-product-card", MarmetoProductCard);
}
